/**
 * Extract a human-readable error message from any axios error.
 * Handles FastAPI/Pydantic validation arrays.
 */
export function extractErrorMessage(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => d?.msg?.replace(/^Value error,\s*/, '') || d?.message || JSON.stringify(d))
      .join('; ');
  }
  return typeof detail === 'object' ? JSON.stringify(detail) : String(detail);
}
